import { withErrorBoundary } from "@sentry/nextjs";
import clsx from "clsx";
import { FC, HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import { useScreenIsAboveBreakpoint } from "hooks/useScreenIsAboveBreakpoint";
import { ComponentMoleculesLinksAndBillboard } from "types/graphql/generated";
import { ResourceDivider } from "../ResourceDivider";
import { Billboard } from "./Billboard/Billboard";
import { FeaturedLinksList } from "./FeaturedLinksList/FeaturedLinksList";

interface Props extends Pick<HTMLAttributes<HTMLDivElement>, "className"> {
  content: ComponentMoleculesLinksAndBillboard;
  title?: string;
}
export const FeaturedLinksListWithBillboard: FC<Props> = withErrorBoundary(
  ({ content: { billboard, links }, title, className }) => {
    const isDesktopView = useScreenIsAboveBreakpoint("lg");

    const optionalContentClasses = clsx({
      "h-full justify-between lg:py-0": links.length > 0,
      "lg:p-4": links.length === 0,
    });

    return (
      <div
        className={twMerge(
          "relative flex h-auto flex-col-reverse justify-between gap-6 p-6 lg:flex-col lg:gap-8 lg:px-4",
          optionalContentClasses,
          className
        )}
      >
        {!isDesktopView && <ResourceDivider />}
        {links.length > 0 && (
          <div className="flex flex-col gap-6">
            {title && <h4 className="text-sm font-semibold text-fog-80 text-opacity-60 lg:pt-4">{title}</h4>}
            <FeaturedLinksList links={links} />
          </div>
        )}
        {billboard && <Billboard content={billboard} />}
      </div>
    );
  },
  {}
);
